import { common } from '../../main/common-sidecar'

export function* generator_bodyAlign(): Generator<number, number, number> {
  // console.log('EDTOR!!!')
  //voyageUiEditor.setOpen(true)

  common.getPhaserScene().cameras.main.setBackgroundColor('#666666')

  while (true) {
    yield 0
  }
  return 0
}
